'use strict';
angular.module('schoolLinqApp').factory('purchasingCategoryService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/purchasingCategory';

		function get(id) {
			return $http.get(endpoint, { params: { id: id } });
		}

		function list() {
			return $http.get(endpoint + '/list');
		}

		function add(category) {
			return $http.put(endpoint, category);
		}

		function update(category) {
			return $http.post(endpoint, category);
		}

		function deleteCategory(id) {
			return $http.delete(endpoint, { params: { id: id } });
		}

		return {
			get: get,
			list: list,
			add: add,
			update: update,
			deleteCategory: deleteCategory,
		};
	},
]);
